import Scene from '@scene';
import { setAnchorsConfiguration, setBasePlateOptions } from '@reducers/selectors/dimension/actions';
import { mergeDeep } from '@services/helper.service';
import { APP_TYPES } from '@config';

export const SET_SQUARE_SCREWS = 'SET_SQUARE_SCREWS';
export const SET_CIRCLE_SCREWS = 'SET_CIRCLE_SCREWS';
export const SET_TRIANGLE_SCREWS = 'SET_TRIANGLE_SCREWS';
export const SET_SCREW_HEIGHT_TYPE = 'SET_SCREW_HEIGHT_TYPE';
export const SET_SCREW_SHIFT_C = 'SET_SCREW_SHIFT_C';
export const SET_SCREW_SHIFT_C1 = 'SET_SCREW_SHIFT_C1';
export const SET_SCREW_PADDING_D = 'SET_SCREW_PADDING_D';
export const SET_SCREW_PADDING_S = 'SET_SCREW_PADDING_S';
export const SET_SCREW_N_COUNT = 'SET_SCREW_N_COUNT';
export const SET_SCREW_MAX_LENGTH = 'SET_SCREW_MAX_LENGTH';
export const TOGGLE_SCREW_MAX_LENGTH = 'TOGGLE_SCREW_MAX_LENGTH';

export const SET_SCREW_OPTIONS = 'SET_SCREW_OPTIONS';

export const SET_SCREW_VERTICAL_STATE_FOR_LINEAR = 'SET_SCREW_VERTICAL_STATE_FOR_LINEAR';

export const RESET_SCREW = 'RESET_SCREW';

export const SET_SCREW_COORDINATES = 'SET_SCREW_COORDINATES';
export const SET_CUSTOM_COORDINATES = 'SET_CUSTOM_COORDINATES';
export const SET_SCREW_STATE = 'SET_SCREW_STATE';

/*
  Action creators
 */
export function setSquareScrews(n, m, ignorePositions, isCustom, isUpdatePadding, toHorizontalMiddle) {
	return (dispatch, getState) => {
		dispatch(setBasePlateOptions({
			spacing: {
					n: isCustom ? n || getState().options.screw.count.n : null,
					m: isCustom ? m || getState().options.screw.count.m : null
			}
		}));

		dispatch(triggerUpdate({
			type: SET_SQUARE_SCREWS,
			n,
			m,
			ignorePositions,
			isCustom,
			isUpdatePadding,
			panel: getState().options.panel,
			toHorizontalMiddle
		}));
	};
}
export function setCircleScrews(n, isCustom) {
	return (dispatch, getState) => {
		dispatch(setBasePlateOptions({
			spacing: {
					n: isCustom ? n || getState().options.screw.count.n : null
			}
		}));

		dispatch(triggerUpdate({
			type: SET_CIRCLE_SCREWS,
			n,
			isCustom
		}));
	};
}
export function setTriangleScrews(n, m, k, isCustom) {
	return (dispatch, getState) => {
		dispatch(setBasePlateOptions({
			spacing: {
					n: isCustom ? n || getState().options.screw.count.n : null,
					m: isCustom ? m || getState().options.screw.count.m : null,
					k: isCustom ? k || getState().options.screw.count.k : null
			}
		}));

		dispatch(triggerUpdate({
			type: SET_TRIANGLE_SCREWS,
			n,
			m,
			k,
			isCustom
		}));
	};
}
export function setScrewHeightType(heightType) {
	return triggerUpdate({ type: SET_SCREW_HEIGHT_TYPE, heightType });
}
export function setScrewShiftC(value) {
	return triggerUpdate({ type: SET_SCREW_SHIFT_C, value });
}
export function setScrewShiftC1(value) {
	return triggerUpdate({ type: SET_SCREW_SHIFT_C1, value });
}
export function setScrewPaddingD(value) {
	return triggerUpdate({ type: SET_SCREW_PADDING_D, value });
}
export function setScrewPaddingS(value) {
	return triggerUpdate({ type: SET_SCREW_PADDING_S, value });
}
export function setScrewNCount(value) {
	return triggerUpdate({ type: SET_SCREW_N_COUNT, value });
}
export function setScrewMaxLength(value) {
	return triggerUpdate({ type: SET_SCREW_MAX_LENGTH, value });
}
export function toggleScrewMaxLength(value) {
	return triggerUpdate({ type: TOGGLE_SCREW_MAX_LENGTH, value });
}

export function setScrewOptions(opt, ignoreObjectUpdate) {
	return (dispatch, getState) => {
		var options = mergeDeep({}, opt); // make sure we don't delete the properties from original object due to the reference
		if (getState().main.appType === APP_TYPES.WOOD_CONNECTION) {
			// VP: Need to do a mapping between the two data structures as they were not followed exactly and involves lots of changes
			let mappedOptions = {};
			if (options.hasOwnProperty('radius'))
				mappedOptions = { ...mappedOptions, diameter: options.radius * 2 };
			if (options.hasOwnProperty('count') && options.count.hasOwnProperty("n"))
				mappedOptions = { ...mappedOptions, n: options.count.n };
			if (options.hasOwnProperty('custom')) { 
				if (options.custom.hasOwnProperty('active'))
					mappedOptions = { ...mappedOptions, isCoordinatesEnabled: options.custom.active };
				if (options.custom.hasOwnProperty('positions')) {
					mappedOptions = { 
						...mappedOptions, 
						coordinates: options.custom.positions.map((screw, idx) => { 
							return { id: idx + 1, x: screw.x, y: screw.y, z: screw.z }; 
						})
					};
				}
			}

			dispatch(setAnchorsConfiguration(mappedOptions));
		} else {
			const isPredefinedBasePlate = (getState().selectors.application[getState().main.appType].predefinedBasePlate &&
				getState().selectors.application[getState().main.appType].predefinedBasePlate.isPredefinedBasePlate) || false;

			if (options.hasOwnProperty('custom')) {
				if (options.custom.hasOwnProperty('positions')) {
					dispatch({
						type: SET_SCREW_COORDINATES,
						appType: getState().main.appType,
						coordinates: options.custom.positions.map((screw) => { return { x: screw.y * -1, y: screw.z * -1 }; })
					});
				}
				// if (options.custom.hasOwnProperty('active')) {
				// 	dispatch({
				// 		type: SET_CUSTOM_COORDINATES,
				// 		appType: getState().main.appType,
				// 		isActive: options.custom.active
				// 	});
				// }
			}
			if (options.hasOwnProperty('padding')) {
				if (isPredefinedBasePlate)
					delete options.padding;
				else {
					if (options.padding.hasOwnProperty('diameter')) {
						const updatedPadding = mergeDeep({}, options.padding, {
							d: options.padding.diameter
						});
						delete updatedPadding.diameter;
						dispatch(setBasePlateOptions({
							spacing: updatedPadding
						}));
					}
					else {
						dispatch(setBasePlateOptions({
							spacing: options.padding
						}));
					}
				}
			}
			if (options.hasOwnProperty('count')) {
				dispatch(setBasePlateOptions({
					spacing: options.count
				}));
			}
		}

		if (ignoreObjectUpdate) {
			dispatch({ type: SET_SCREW_OPTIONS, options });
		} else {
			return dispatch(triggerUpdate({ type: SET_SCREW_OPTIONS, options }));
		}
	};
}

export function setScrewVerticalStateForLinear(value) {
  return triggerUpdate({ type: SET_SCREW_VERTICAL_STATE_FOR_LINEAR, value });
}

export function resetScrew(appType) {
	return (dispatch, getState) => {
		dispatch(triggerUpdate({ type: RESET_SCREW, appType, country: getState().main.localization.country }));
	};
}

export function setScrewState(state) {
	return (dispatch) => {
	  dispatch(triggerUpdate({ type: SET_SCREW_STATE, state }));
	};
}

function triggerUpdate(event) {
	return (dispatch, getState) => {
		dispatch(event);

		Scene.updateScrew(getState().options.screw);
	};
}



// WEBPACK FOOTER //
// ./src/reducers/options/screw/actions.js